// Hide quick-add when product has tag "personalised" (or "personalized")
;(() => {
  const cache = new Map(); // handle -> boolean

  const getHandle = (el) => {
    const link = el.closest('.product-card, [data-product-handle]')
      ?.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    return decodeURIComponent(m[1]).replace(/^en-gb\//, '').replace(/\/$/, '');
  };

  const shouldHide = async (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return cache.set(handle, false).get(handle);
      const p = await res.json();
      const tags = Array.isArray(p.tags) ? p.tags
        : String(p.tags || '').split(',').map(s => s.trim());
      const hit = tags.some(t => {
        const k = t.toLowerCase();
        return k === 'personalised' || k === 'personalized';
      });
      cache.set(handle, hit);
      return hit;
    } catch {
      cache.set(handle, false);
      return false;
    }
  };

  const run = async (root = document) => {
    const nodes = root.querySelectorAll('quick-add-component');
    for (const el of nodes) {
      if (el.__qaChecked) continue;
      const handle = getHandle(el);
      el.__qaChecked = true;
      if (!handle) continue;
      if (await shouldHide(handle)) el.remove();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else run();

  document.addEventListener('shopify:section:load', e => run(e.target));
})();



/* ===== custom-events.js ===== */
console.log("[custom-events] loaded", new Date().toISOString())

window.Shopify = window.Shopify || {}

const MOBILE_BREAKPOINT = 749
window.__isMobileCart = () =>
  window.matchMedia(`(max-width:${MOBILE_BREAKPOINT - 1}px)`).matches

;(() => {
  const mql = window.matchMedia(`(max-width:${MOBILE_BREAKPOINT - 1}px)`)
  const ensureMobileState = () => {
    if (!window.__isMobileCart()) return
    document
      .querySelectorAll('cart-drawer-component.cart-drawer[auto-open]')
      .forEach((el) => el.removeAttribute("auto-open"))
  }
  ensureMobileState()
  mql.addEventListener?.("change", ensureMobileState)
})()

// === Global mobile cart redirect (no drawer flash) ===
;(() => {
  if (location.pathname === "/cart" || location.pathname === "/cart/") return

  const cartUrl = ((window.Shopify?.routes?.root) || "/") + "cart"
  const OPENERS = '[aria-controls="cart-drawer"], [data-open-cart], button[on\\:click="/open"]'

  function findOpenerFromEvent(e) {
    if (e.composedPath) {
      for (const n of e.composedPath()) {
        if (n && n.nodeType === 1 && n.matches?.(OPENERS)) return n
      }
    }
    const t = e.target
    return t?.closest?.(OPENERS) || null
  }

  function redirectIfMobile(e) {
    if (!window.__isMobileCart?.()) return
    // Check if mobile drawer is enabled via theme setting
    const drawer = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
    if (drawer) return // Don't redirect if mobile drawer is enabled
    const opener = findOpenerFromEvent(e)
    if (!opener) return
    e.preventDefault()
    e.stopImmediatePropagation()
    e.stopPropagation?.()
    queueMicrotask(() => { window.location.assign(cartUrl) })
  }

  // Fire BEFORE theme logic:
  document.addEventListener('pointerdown', redirectIfMobile, true)
  document.addEventListener('mousedown', redirectIfMobile, true)
  document.addEventListener('touchstart', redirectIfMobile, { capture: true, passive: false })
  document.addEventListener('click', redirectIfMobile, true)

  // A11y: keyboard activation
  document.addEventListener('keydown', (e) => {
    if (!window.__isMobileCart?.()) return
    // Check if mobile drawer is enabled via theme setting
    const drawer = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
    if (drawer) return // Don't redirect if mobile drawer is enabled
    if (e.key !== 'Enter' && e.key !== ' ') return
    const opener = findOpenerFromEvent(e)
    if (!opener) return
    e.preventDefault()
    e.stopImmediatePropagation()
    e.stopPropagation?.()
    queueMicrotask(() => { window.location.assign(cartUrl) })
  }, true)
})()


;(() => {
  function addSitemapToPopover() {
    const list = document.querySelector('.policy_list')
    if (!list || list.querySelector('[data-sitemap-link]')) return

    const sample = list.querySelector('a[href*="/policies/"]')
    const prefix = sample
      ? new URL(sample.href, location.origin).pathname.split('/policies')[0].replace(/\/$/, '')
      : ''

    const li = document.createElement('li')
    const a = document.createElement('a')
    a.href = (prefix + '/pages/site-map').replace(/\/{2,}/g, '/')
    a.className = 'footer-utilities__text'
    a.textContent = 'Sitemap'
    a.dataset.sitemapLink = 'true'

    li.appendChild(a)
    list.appendChild(li)
  }

  document.addEventListener('DOMContentLoaded', addSitemapToPopover)
  document.addEventListener('shopify:section:load', addSitemapToPopover)
})()





const ON_CART_PAGE = location.pathname === "/cart" || location.pathname === "/cart/"

/* Gate cart drawer: block early opens, reopen after delay (and DOM ready) */
;(() => {
  if (ON_CART_PAGE) return
  const DRAWER = "cart-drawer-component.cart-drawer"
  const DIALOG = DRAWER + " dialog.cart-drawer__dialog"
  const OPEN_BTN = DRAWER + ' button[on\\:click="/open"]'
  const EVT_CART_UPDATE = (window.ThemeEvents && window.ThemeEvents.cartUpdate) || "cart:update"

  const ARM_WINDOW_MS = 2000
  const PAUSE_MS = 1000
  let isFirstOpen = true

  let armedAt = 0
  let restoreAutoTimer = null
  let reopenTimer = null

  const comp = () => document.querySelector(DRAWER)
  const dlg = () => document.querySelector(DIALOG)
  const isOpen = () => !!dlg()?.open
  const closeNow = () => {
    const d = dlg()
    try {
      if (d?.open) d.close()
      else d?.removeAttribute("open")
    } catch (_) {}
  }
  const openDrawer = () => {
    // Check if mobile drawer is enabled, otherwise block on mobile
    const drawer = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
    if (window.__isMobileCart() && !drawer) return
    const c = comp()
    const d = dlg()
    const btn = c?.querySelector(OPEN_BTN)
    if (typeof c?.open === "function") c.open()
    else if (btn) btn.click()
    else if (d?.showModal) d.showModal()
    else d?.setAttribute("open", "")
    if (isFirstOpen) {
      setTimeout(() => {
        closeNow()
        setTimeout(() => {
          const c2 = comp()
          const d2 = dlg()
          const btn2 = c2?.querySelector(OPEN_BTN)
          const drawer2 = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
          if (!window.__isMobileCart() || drawer2) {
            if (typeof c2?.open === "function") c2.open()
            else if (btn2) btn2.click()
            else if (d2?.showModal) d2.showModal()
            else d2?.setAttribute("open", "")
          }
          isFirstOpen = false
        }, 100)
      }, 5)
    }
  }

  function disarm() {
    armedAt = 0
    if (restoreAutoTimer) {
      clearTimeout(restoreAutoTimer)
      restoreAutoTimer = null
    }
    if (reopenTimer) {
      clearTimeout(reopenTimer)
      reopenTimer = null
    }
  }

  document.addEventListener(
    "click",
    (e) => {
      const t = e.target
      if (!t) return

      const addForm = t.closest('form[action*="/cart/add"]')
      const isAddToCartButton = !!(
        addForm ||
        t.closest("[data-add-to-cart]") ||
        t.closest("quick-add-component, [data-quick-add]") ||
        t.closest('.product-card [name="add"]')
      )

      if (isAddToCartButton) {
        armedAt = Date.now()
        const c = comp()
        if (c?.hasAttribute("auto-open")) {
          c.removeAttribute("auto-open")
          restoreAutoTimer = setTimeout(() => {
            if (!window.__isMobileCart()) c.setAttribute("auto-open", "")
          }, ARM_WINDOW_MS)
        }
      }
    },
    true,
  )

  document.addEventListener(
    "cart-drawer:open",
    (e) => {
      if (!armedAt || Date.now() - armedAt > ARM_WINDOW_MS) return
      e.stopImmediatePropagation?.()
      closeNow()
      if (reopenTimer) clearTimeout(reopenTimer)
      reopenTimer = setTimeout(() => {
        openDrawer()
        disarm()
      }, PAUSE_MS)
    },
    true,
  )

  document.addEventListener(EVT_CART_UPDATE, () => {
    if (!armedAt || Date.now() - armedAt > ARM_WINDOW_MS) return
    if (reopenTimer) clearTimeout(reopenTimer)
    reopenTimer = setTimeout(() => {
      if (!isOpen()) openDrawer()
      disarm()
    }, PAUSE_MS)
  })
})()

/* Drawer: close → pause → reopen at top (qty change inside drawer) */
;(() => {
  if (ON_CART_PAGE) return

  const DRAWER = "cart-drawer-component.cart-drawer"
  const DIALOG = DRAWER + " dialog.cart-drawer__dialog"
  const OPEN_BTN = DRAWER + ' button[on\\:click="/open"]'
  const EVT_CART_UPDATE = (window.ThemeEvents && window.ThemeEvents.cartUpdate) || "cart:update"

  const WINDOW_MS = 2000
  const PAUSE_MS = 0
  const RESTORE_MS = 1200

  let armedAt = 0
  let suppressUntil = 0
  let mo = null

  const comp = () => document.querySelector(DRAWER)
  const dlg = () => document.querySelector(DIALOG)

  document.addEventListener(
    "quantity-selector:update",
    (e) => {
      if (e.target && e.target.closest(DRAWER)) armedAt = Date.now()
    },
    true,
  )

  document.addEventListener(
    "click",
    (e) => {
      if (e.target && e.target.closest(OPEN_BTN)) armedAt = 0
    },
    true,
  )

  function startSuppressObserver() {
    if (mo) mo.disconnect()
    const d = dlg()
    if (!d) return
    mo = new MutationObserver(() => {
      if (Date.now() < suppressUntil && d.open) {
        try {
          d.close()
        } catch (_) {
          d.removeAttribute("open")
        }
      }
    })
    mo.observe(d, { attributes: true, attributeFilter: ["open"] })
  }

  document.addEventListener(
    EVT_CART_UPDATE,
    () => {
      const now = Date.now()
      if (!armedAt || now - armedAt > WINDOW_MS) return

      const c = comp()
      const d = dlg()
      if (!c || !d) {
        armedAt = 0
        return
      }

      const wasOpen = d.open
      const hadAuto = c.hasAttribute("auto-open")
      if (hadAuto) c.removeAttribute("auto-open")

      // Check if mobile drawer is enabled
      const drawer = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
      const isMobile = window.__isMobileCart() && drawer

      // On mobile: if drawer is already open, just scroll to top without closing/reopening
      if (isMobile && wasOpen) {
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            const s = c?.querySelector(".cart-drawer__content") || d
            if (s) {
              const prev = s.style.scrollBehavior
              s.style.scrollBehavior = "auto"
              s.scrollTop = 0
              s.scrollTo?.(0, 0)
              s.style.scrollBehavior = prev || ""
            }
          }),
        )

        if (hadAuto && c)
          setTimeout(() => c.setAttribute("auto-open", ""), RESTORE_MS)
        armedAt = 0
        return
      }

      // Desktop or closed drawer: use original close/reopen behavior
      suppressUntil = now + PAUSE_MS
      startSuppressObserver()
      try {
        if (d.open) d.close()
        else d.removeAttribute("open")
      } catch (_) {}

      setTimeout(() => {
        suppressUntil = 0
        if (mo) {
          mo.disconnect()
          mo = null
        }

        const c2 = comp()
        const d2 = dlg()
        const btn = c2?.querySelector(OPEN_BTN)

        if (!window.__isMobileCart()) {
          if (typeof c2?.open === "function") c2.open()
          else if (btn) btn.click()
          else if (d2?.showModal) d2.showModal()
          else d2?.setAttribute("open", "")
        }

        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            const s = c2?.querySelector(".cart-drawer__content") || d2
            if (s) {
              const prev = s.style.scrollBehavior
              s.style.scrollBehavior = "auto"
              s.scrollTop = 0
              s.scrollTo?.(0, 0)
              s.style.scrollBehavior = prev || ""
            }
          }),
        )

        if (hadAuto && c2 && !window.__isMobileCart())
          setTimeout(() => c2.setAttribute("auto-open", ""), RESTORE_MS)
        armedAt = 0
      }, PAUSE_MS)
    },
    true,
  )
})()

/* Quick-add: suppress early auto-open → wait for markup → open */
;(() => {
  if (ON_CART_PAGE) return

  const DRAWER = "cart-drawer-component.cart-drawer"
  const DIALOG = DRAWER + " dialog.cart-drawer__dialog"
  const OPEN_BTN = DRAWER + ' button[on\\:click="/open"]'
  const EVT_CART_UPDATE = (window.ThemeEvents && window.ThemeEvents.cartUpdate) || "cart:update"

  const QUICK_ADD_CLICK = ["quick-add-component", "[data-quick-add]", '.product-card [name="add"]'].join(",")
  const QUICK_ADD_SUBMIT = [
    '#quick-add-dialog form[action^="/cart/add"] [type="submit"]',
    '#quick-add-dialog product-form [type="submit"]',
    '#quick-add-dialog product-form-component [type="submit"]',
  ].join(",")

  const WINDOW_MS = 3000
  const DELAY_MS = 200
  const READY_MS = 1500

  let qaArmedAt = 0
  let restoringAuto = null

  const comp = () => document.querySelector(DRAWER)
  const dlg = () => document.querySelector(DIALOG)

  function isOpen() {
    const d = dlg()
    return !!d && d.open
  }

  function closeNow() {
    const d = dlg()
    try {
      if (d?.open) d.close()
      else d?.removeAttribute("open")
    } catch (_) {}
  }

  function openDrawer() {
    // Check if mobile drawer is enabled, otherwise block on mobile
    const drawer = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
    if (window.__isMobileCart() && !drawer) return
    const c = comp()
    const d = dlg()
    const btn = c?.querySelector(OPEN_BTN)
    if (typeof c?.open === "function") c.open()
    else if (btn) btn.click()
    else if (d?.showModal) d.showModal()
    else d?.setAttribute("open", "")
  }

  function waitForReady(deadline) {
    return new Promise((resolve) => {
      ;(function tick() {
        const summary =
          document.querySelector(".cart-drawer .cart__summary-actions") ||
          document.querySelector(".cart-drawer .cart-drawer__summary")
        const checkout = document.querySelector(
          '.cart-drawer #checkout, .cart-drawer button[name="checkout"], .cart-drawer [data-checkout-button]',
        )
        if ((summary && checkout) || performance.now() > deadline) return resolve()
        requestAnimationFrame(tick)
      })()
    })
  }

  function disarm() {
    qaArmedAt = 0
    if (restoringAuto) {
      clearTimeout(restoringAuto)
      restoringAuto = null
    }
  }

  document.addEventListener(
    "click",
    (e) => {
      if (e.target && (e.target.closest(QUICK_ADD_CLICK) || e.target.closest(QUICK_ADD_SUBMIT))) {
        qaArmedAt = Date.now()
        const c = comp()
        if (c?.hasAttribute("auto-open")) {
          c.removeAttribute("auto-open")
          restoringAuto = setTimeout(() => {
            if (!window.__isMobileCart()) c.setAttribute("auto-open", "")
          }, WINDOW_MS)
        }
      }
    },
    true,
  )

  document.addEventListener(
    "cart-drawer:open",
    () => {
      if (!qaArmedAt || Date.now() - qaArmedAt > WINDOW_MS) return
      closeNow()
    },
    true,
  )

  document.addEventListener(EVT_CART_UPDATE, async () => {
    if (!qaArmedAt || Date.now() - qaArmedAt > WINDOW_MS) return
    closeNow()
    const deadline = performance.now() + READY_MS
    await waitForReady(deadline)
    setTimeout(() => {
      if (!isOpen()) openDrawer()
      const c = comp()
      if (c && !c.hasAttribute("auto-open") && !window.__isMobileCart()) {
        setTimeout(() => c.setAttribute("auto-open", ""), 600)
      }
      disarm()
    }, DELAY_MS)
  })
})()

/* Mobile: send users to /cart instead of opening the drawer */
;(() => {
  if (ON_CART_PAGE) return

  var cartUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart"

  function wire(root) {
    root = root || document
    root.querySelectorAll("cart-drawer-component.cart-drawer").forEach((comp) => {
      var openBtns = comp.querySelectorAll(
        'button[on\\:click="/open"], [data-open-cart], [aria-controls="cart-drawer"]',
      )
      openBtns.forEach((btn) => {
        btn.addEventListener(
          "click",
          (e) => {
            if (!window.__isMobileCart()) return
            // Check if mobile drawer is enabled via theme setting
            if (comp.hasAttribute("data-mobile-drawer-enabled")) return
            e.preventDefault()
            e.stopImmediatePropagation()
            window.location.assign(cartUrl)
          },
          { capture: true },
        )
      })
      if (window.__isMobileCart() && comp.hasAttribute("auto-open") && !comp.hasAttribute("data-mobile-drawer-enabled")) comp.removeAttribute("auto-open")
    })

    root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (!form.querySelector('input[name="return_to"]')) {
        var input = document.createElement("input")
        input.type = "hidden"
        input.name = "return_to"
        input.value = cartUrl
        form.appendChild(input)
      }
    })
  }

  function init() {
    wire(document)
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init)
  else init()
  document.addEventListener("shopify:section:load", (e) => {
    wire(e.target)
  })

  // Track if we've already handled this open event to prevent duplicate handling
  let lastOpenEventTime = 0
  const OPEN_EVENT_DEBOUNCE_MS = 150
  let isHandlingOpen = false
  let duplicateCheckTimer = null

  // Check for and remove duplicate drawers (only when actually needed)
  function ensureSingleDrawer() {
    const drawers = document.querySelectorAll("cart-drawer-component.cart-drawer")
    if (drawers.length > 1) {
      // Find the one that's actually in the DOM properly (has a parent)
      let primaryDrawer = null
      for (let i = 0; i < drawers.length; i++) {
        if (drawers[i].parentElement && drawers[i].isConnected) {
          primaryDrawer = drawers[i]
          break
        }
      }
      
      // If no primary found, use the first one
      if (!primaryDrawer) primaryDrawer = drawers[0]
      
      // Remove all others
      for (let i = 0; i < drawers.length; i++) {
        if (drawers[i] === primaryDrawer) continue
        
        const dlg = drawers[i].querySelector("dialog.cart-drawer__dialog")
        if (dlg) {
          try {
            if (dlg.open) dlg.close()
          } catch (_) {}
          dlg.removeAttribute('open')
        }
        // Only remove if it's not connected or is a true duplicate
        if (!drawers[i].isConnected || drawers[i].parentElement !== primaryDrawer.parentElement) {
          drawers[i].remove()
        }
      }
    }
  }

  // Only check for duplicates on drawer open, not periodically
  document.addEventListener(
    "cart-drawer:open",
    (e) => {
      // Debounce to prevent multiple rapid fires
      const now = Date.now()
      if (now - lastOpenEventTime < OPEN_EVENT_DEBOUNCE_MS) {
        e.stopImmediatePropagation()
        e.preventDefault?.()
        e.stopPropagation?.()
        return
      }
      lastOpenEventTime = now

      // Only redirect on actual mobile devices, not just small viewports
      // Check if it's a touch device AND small viewport to avoid desktop issues
      const isMobileDevice = window.__isMobileCart() && ('ontouchstart' in window || navigator.maxTouchPoints > 0)
      if (!isMobileDevice) {
        // On desktop, check for duplicates after a short delay to avoid interfering with normal opening
        if (duplicateCheckTimer) clearTimeout(duplicateCheckTimer)
        duplicateCheckTimer = setTimeout(() => {
          ensureSingleDrawer()
        }, 100)
        return
      }
      
      // Check if mobile drawer is enabled via theme setting
      const drawer = document.querySelector('cart-drawer-component[data-mobile-drawer-enabled]')
      if (drawer) return // Don't redirect if mobile drawer is enabled
      
      // Prevent the drawer from opening at all on mobile (without drawer enabled)
      if (isHandlingOpen) {
        e.stopImmediatePropagation()
        e.preventDefault?.()
        e.stopPropagation?.()
        return
      }
      
      isHandlingOpen = true
      e.stopImmediatePropagation()
      e.preventDefault?.()
      e.stopPropagation?.()
      
      const dlg = document.querySelector("cart-drawer-component.cart-drawer dialog.cart-drawer__dialog")
      // Ensure drawer is closed before redirecting
      if (dlg) {
        try {
          if (dlg.open) dlg.close()
        } catch (_) {}
        // Remove open attribute to prevent any visual flash
        dlg.removeAttribute('open')
      }
      
      // Use setTimeout to ensure drawer is fully closed before redirect
      setTimeout(() => {
        isHandlingOpen = false
        window.location.assign(cartUrl)
      }, 0)
    },
    true,
  )
})();


// Remove header cart icon on the cart page (with debug logs)
(() => {
  const TAG = '[custom-events][cart-icon-remove]';

  const isCartPage = () => /\/cart\/?$/.test(location.pathname);

  function run(scope) {
    const onCart = isCartPage();
    console.log(TAG, 'run()', { path: location.pathname, onCart, scope: scope || 'document' });
    if (!onCart) return;

    const header = document.querySelector('header, header-component, .header');
    const root = header || document;

    const nodes = root.querySelectorAll('a.header-actions__action.action__cart');
    console.log(TAG, 'found cart anchors:', nodes.length);

    nodes.forEach((el, i) => {
      el.remove();
      console.log(TAG, `removed #${i + 1}`);
    });
  }

  // Initial + DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run('DOMContentLoaded'));
  } else {
    run('immediate');
  }

  // Catch late header JS
  setTimeout(() => run('timeout-500ms'), 500);

  // Re-apply if header section reloads
  document.addEventListener('shopify:section:load', (e) => {
    if (
      e.target.matches('header, header-component, .header') ||
      /header/i.test(e.target.id || '')
    ) {
      console.log(TAG, 'section reload detected → re-run');
      run('section:load');
    }
  });
})();

// Disabled Sunday / Monday post 13:00 on Saturday

/* --- Delivery calendar: disable Sun/Mon on weekend rules --- */
(() => {
  const TZ = 'Europe/London';

  const fmt = (now, opt) => new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...opt }).format(now);
  const iso = now => new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(now);

  function targetIsos() {
    const now = new Date();
    const weekday = fmt(now, { weekday: 'short' }); // 'Sat'/'Sun'
    const hour = parseInt(fmt(now, { hour: '2-digit', hour12: false }), 10);
    const todayIso = iso(now);

    const addDays = (isoStr, days) => {
      const d = new Date(isoStr + 'T00:00:00Z');
      d.setUTCDate(d.getUTCDate() + days);
      return d.toISOString().slice(0, 10);
    };

    if (weekday === 'Sat' && hour >= 13) return [addDays(todayIso, 1), addDays(todayIso, 2)];
    if (weekday === 'Sun') return [todayIso, addDays(todayIso, 1)];
    return [];
  }

  function apply(root = document) {
    const dates = targetIsos();
    if (!dates.length) return;

    const table = root.querySelector('#cc-calendar-table');
    if (!table) return;

    dates.forEach(d => {
      table.querySelectorAll(`td[area-label="${d}"], td[aria-label="${d}"]`).forEach(td => {
        td.classList.remove('is-abled');
        td.classList.add('is-disabled');
        td.setAttribute('aria-disabled', 'true');
        td.tabIndex = -1;
        td.style.pointerEvents = 'none';
        td.style.opacity = '0.45';
        td.style.cursor = 'not-allowed';
      });
    });
  }

  // 1) Try on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  } else {
    apply();
  }

  // 2) Re-apply when calendar appears or re-renders
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (n.id === 'cc-calendar' || n.querySelector?.('#cc-calendar-table'))) {
          apply(n);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 3) Re-apply when user navigates months or opens the picker
  document.addEventListener('click', e => {
    if (
      e.target?.id === 'cc-next-button' || e.target?.id === 'cc-back-button' ||
      e.target?.closest?.('#cc-next-button') || e.target?.closest?.('#cc-back-button') ||
      e.target?.id === 'cc-calendar' || e.target?.closest?.('#cc-calendar')
    ) {
      setTimeout(apply, 0);
    }
  });

  // 4) Shopify section loads (theme editor / dynamic loads)
  document.addEventListener('shopify:section:load', e => apply(e.target));
})();
